// extracted by mini-css-extract-plugin
export default {"shell":"EAy3viWj","main":"JOoq1Wyd","content":"nmZ9zPkz"};